/* eslint-disable react/display-name */
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import React from "react";
import moment from 'moment'
import { Tag } from "antd";
import LineIndicator from "../../../components/dashboard/Crypto/LineIndicator";
import SubjectTag from "../../../components/dashboard/Session/SubjectTile";
import { getSubjectByName } from "../../../constants/AppConstants";
export const practice_session_columns =  [
  {
    title: 'Chapter',
    dataIndex: 'chapter',
    key: 'chapter',
    render: (text,item) =>(<div><span>{text}</span><div><SubjectTag subject={item.subject}/></div></div>),
  },
  // {
  //   title: 'Subject',
  //   dataIndex: 'subject',
  //   key: 'subject',
  //   width: 100,
  // },
  {
    title: 'Score',
    dataIndex: 'accuracy',
    key: 'accuracy',
    width: 80,
    render :(text,item)=>{
      return `${item.correct_answers}/${item.total_questions}`
    }
  },
  {
    title: 'Date',
    dataIndex: 'start_time',
    key: 'start_time',
    // width: 100,
    render :(text)=>{
      return moment(parseInt(text)).fromNow()
    },
    sorter:(a,b)=> moment(parseInt(a.start_time))-moment(parseInt(b.start_time)),
    sortDirections: ['descend', 'ascend'],
  }
];

export const chapter_progress_columns = [
  {
    dataIndex: 'name',
    key: 'name',
    render: (text, item) => {
      const thisSubject = getSubjectByName(item.subjectname)
      return (
        <LineIndicator width={`${item.accuracy }%`} title={text} title2={`${item.coverage ? item.coverage : 0}% Completed`} color={`${thisSubject.color}`} value={`${item.accuracy}%`} />
      )
    },
  }

];

export const challenge_session_columns =  [
  {
    title: 'Chapter',
    dataIndex: 'chapter',
    key: 'chapter',
    render: (text,item) =>(<div><span>{text}</span><div><SubjectTag subject={item.subject}/></div></div>),
  },
  // {
  //   title: 'Subject',
  //   dataIndex: 'subject',
  //   key: 'subject',
  //   width: 100,
  // },
  {
    title: 'Score',
    dataIndex: 'accuracy',
    key: 'accuracy',
    // width: 100,
    width: 80,
    render :(text,item)=>{
      return `${item.correct_answers}/${item.total_questions}`
    }
  },
  {
    title: 'Result',
    dataIndex: 'won',
    key: 'won',
    width: 60,
    // eslint-disable-next-line react/display-name
    render :(text)=>{
      const tagText = text?"Won":"Lost";
      return (text?
            <Tag color={"#52c41a"} className="gx-tag-style-subject-medium">
              {tagText.toUpperCase()}
            </Tag>
            :
            <Tag color={"rgba(234, 63, 71, 0.78)"} className="gx-tag-style-subject-medium">
              {tagText.toUpperCase()}
            </Tag>)
      // return text?<CheckCircleTwoTone  twoToneColor="#52c41a" />:<CloseCircleTwoTone twoToneColor="#eb2f96" />
    }
  },
  {
    title: 'Date',
    dataIndex: 'start_time',
    key: 'start_time',
    // width: 100,
    render :(text)=>{
      return moment(parseInt(text)).fromNow()
    },
    sorter:(a,b)=> moment(parseInt(a.start_time))-moment(parseInt(b.start_time)),
    sortDirections: ['descend', 'ascend'],
  }
];